const destinations = ["1", "2", "2.R", "2.L"];

export default destinations;
